import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import InviteAuthRedirect from './InviteAuthRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Loading spinner while checking auth
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rowing-blue"></div>
      </div>
    );
  }

  if (!user) {
    if (location.pathname === '/rower/invitations') {
      const invitationToken = new URLSearchParams(location.search).get('token')?.trim();
      if (invitationToken) {
        const returnTo = `${location.pathname}${location.search}${location.hash}`;
        return <InviteAuthRedirect returnTo={returnTo} invitationToken={invitationToken} />;
      }
    }

    // Preserve target path/query so auth flows (e.g. invitation tokens) survive login redirect.
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    const loginUrl =
      returnTo && returnTo !== '/login'
        ? `/login?returnTo=${encodeURIComponent(returnTo)}`
        : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
